import React from 'react';
import { observer } from "mobx-react";
import { BookingSearchFieldsContainerBox } from "../common/booking-search-fields-container.box";
import { StringFieldEditorComponent } from "../../../../components/forms/string-field/string-field-editor.component";
import { BookingSearchCommonFieldsComponent } from "../common/booking-search-common-fields.component";
import {SearchByLastNameStrategy} from "./search-by-last-name.strategy";

export const SearchByLastNameComponent: React.FC<{ strategy: SearchByLastNameStrategy }> = observer((props) => {
    const fields = props.strategy.fields;

    return (
        <BookingSearchFieldsContainerBox>
            <StringFieldEditorComponent field={fields.lastName} showClearButton={true}/>
            <StringFieldEditorComponent field={fields.firstName} showClearButton={true}/>
            <BookingSearchCommonFieldsComponent fields={fields} />
        </BookingSearchFieldsContainerBox>
    );
});
